export default __webpack_public_path__ + "static/media/project3.100f1a7f.jpg";